/* ==========================================================================
   KOLP — Standard product form
   <product-form> custom element for non-bundle products: colour swatches +
   size buttons -> variant resolution -> add to cart -> cart drawer.
   Depends on: bundle-pricing.js (money), kolp-core.js
   ========================================================================== */
(function () {
  'use strict';
  var KOLP = window.KOLP || {};
  var P = window.KOLPPricing;
  var money = function (m) { return P ? P.formatMoney(m) : '€ ' + (m / 100).toFixed(2); };

  class ProductForm extends HTMLElement {
    connectedCallback() {
      try {
        this.product = JSON.parse(this.querySelector('.pf-product').textContent);
      } catch (e) { console.error('KOLP: invalid product JSON', e); return; }

      this.priceEls = KOLP.$$('[data-pf-price]', this);
      this.compareEls = KOLP.$$('[data-pf-compare]', this);
      this.pctEls = KOLP.$$('[data-pf-pct]', this);
      this.stickyPriceEls = KOLP.$$('[data-bb-total]'); // sticky CTA bar (outside this element)
      this.ctaBtn = this.querySelector('[data-pf-cta]');
      this.qtyInput = this.querySelector('[data-pf-qty]');
      this.errorEl = this.querySelector('[data-pf-error]');
      this.swatchWrap = this.querySelector('[data-pf-colors]');
      this.sizeWrap = this.querySelector('[data-pf-sizes]');
      this.colorNameEls = KOLP.$$('[data-pf-color-name]', this);
      this.i18nAddToCart = (this.ctaBtn && this.ctaBtn.dataset.i18nAddToCart) || 'Add to cart —';
      this.i18nSoldOut = (this.ctaBtn && this.ctaBtn.dataset.i18nSoldOut) || 'Sold out';
      this.i18nChooseOption = (this.ctaBtn && this.ctaBtn.dataset.i18nChooseOption) || 'Please choose an available option.';
      this.i18nAddToCartError = (this.ctaBtn && this.ctaBtn.dataset.i18nAddToCartError) || 'Could not add to cart: __MESSAGE__ Please try again.';
      this.i18nOfflineError = (this.ctaBtn && this.ctaBtn.dataset.i18nOfflineError) || 'You appear to be offline. Check your connection and try again.';

      this.buildIndex();

      this.state = {
        color: this.dataset.initialColor || (this.product.colors[0] && this.product.colors[0].name) || '',
        size: this.dataset.initialSize || this.firstAvailableSize() || (this.product.sizes[0] || ''),
        qty: 1
      };
      // if the product has no size option, size stays ''
      if (!this.product.sizes.length) this.state.size = '';
      if (!this.product.colors.length) this.state.color = '';

      this.bind();
      this.sync();

      KOLP.analytics && KOLP.analytics.track('view_item', {
        item_id: this.product.id, item_name: this.product.title,
        price: (this.currentVariant() || {}).price / 100
      });
    }

    buildIndex() {
      this.byKey = {};
      this.hasColor = this.product.colors.length > 0;
      this.hasSize = this.product.sizes.length > 0;
      (this.product.variants || []).forEach(function (v) {
        this.byKey[(v.color || '') + '|::|' + (v.size || '')] = v;
      }, this);
    }

    currentVariant() {
      return this.byKey[(this.state.color || '') + '|::|' + (this.state.size || '')] || null;
    }
    available(color, size) {
      var v = this.byKey[(color || '') + '|::|' + (size || '')];
      return !!(v && v.available);
    }
    firstAvailableSize() {
      var sizes = this.product.sizes;
      for (var i = 0; i < sizes.length; i++) {
        if ((this.product.variants || []).some(function (v) { return v.size === sizes[i] && v.available; })) return sizes[i];
      }
      return sizes[0];
    }
    colorImage(color) {
      var imgs = this.product.imagesByColor || {};
      return (imgs[color] && imgs[color][0]) || this.product.defaultImage || '';
    }

    bind() {
      var self = this;
      KOLP.$$('[data-color]', this.swatchWrap || this).forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.dataset.unavailable === 'true') return;
          self.state.color = btn.dataset.color;
          self.sync();
          KOLP.analytics && KOLP.analytics.track('select_color', { color: self.state.color });
          KOLP.bus.emit('builder:color', { color: self.state.color });
        });
      });
      KOLP.$$('[data-size]', this.sizeWrap || this).forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.dataset.unavailable === 'true') return;
          self.state.size = btn.dataset.size;
          self.sync();
          KOLP.analytics && KOLP.analytics.track('select_size', { size: self.state.size });
        });
      });
      var minus = this.querySelector('[data-pf-qty-minus]');
      var plus = this.querySelector('[data-pf-qty-plus]');
      if (minus) minus.addEventListener('click', function () { self.setQty(self.state.qty - 1); });
      if (plus) plus.addEventListener('click', function () { self.setQty(self.state.qty + 1); });
      if (this.qtyInput) this.qtyInput.addEventListener('change', function () { self.setQty(parseInt(self.qtyInput.value, 10) || 1); });

      if (this.ctaBtn) this.ctaBtn.addEventListener('click', function () { self.addToCart(); });
      KOLP.$$('[data-size-guide]', this).forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); KOLP.bus.emit('sizeguide:open'); });
      });
    }

    setQty(q) {
      this.state.qty = Math.max(1, q || 1);
      if (this.qtyInput) this.qtyInput.value = this.state.qty;
      this.sync();
    }

    sync() {
      var self = this;
      // swatch state — a colour is only disabled if it is sold out in every size
      KOLP.$$('[data-color]', this.swatchWrap || this).forEach(function (btn) {
        var c = btn.dataset.color;
        var sel = c === self.state.color;
        btn.setAttribute('aria-pressed', sel ? 'true' : 'false');
        btn.setAttribute('aria-checked', sel ? 'true' : 'false');
        var anySize = self.product.variants.some(function (v) { return v.color === c && v.available; });
        if (anySize) btn.removeAttribute('data-unavailable');
        else btn.setAttribute('data-unavailable', 'true');
      });
      // size state + availability given the current colour
      KOLP.$$('[data-size]', this.sizeWrap || this).forEach(function (btn) {
        var s = btn.dataset.size;
        btn.setAttribute('aria-pressed', s === self.state.size ? 'true' : 'false');
        if (self.available(self.state.color, s)) btn.removeAttribute('data-unavailable');
        else btn.setAttribute('data-unavailable', 'true');
      });
      // if current combo unavailable, try to snap size to an available one for this colour
      if (this.hasSize && !this.available(this.state.color, this.state.size)) {
        var alt = this.product.sizes.find(function (s) { return self.available(self.state.color, s); });
        if (alt) {
          this.state.size = alt;
          KOLP.$$('[data-size]', this.sizeWrap || this).forEach(function (btn) {
            btn.setAttribute('aria-pressed', btn.dataset.size === alt ? 'true' : 'false');
          });
        }
      }

      // colour name readout next to the "Colour —" label
      this.colorNameEls.forEach(function (el) { el.textContent = self.state.color; });

      var v = this.currentVariant();
      var soldOut = !v || !v.available;

      this.priceEls.forEach(function (el) { el.textContent = v ? money(v.price) : money(self.product.price); });
      this.stickyPriceEls.forEach(function (el) { el.textContent = money((v ? v.price : self.product.price) * self.state.qty); });
      this.compareEls.forEach(function (el) {
        if (v && v.compare_at_price && v.compare_at_price > v.price) {
          el.textContent = money(v.compare_at_price); el.hidden = false;
        } else { el.hidden = true; }
      });
      this.pctEls.forEach(function (el) {
        if (v && v.compare_at_price && v.compare_at_price > v.price) {
          el.textContent = '–' + Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + '%';
          el.hidden = false;
        } else { el.hidden = true; }
      });

      if (this.ctaBtn) {
        var idle = this.ctaBtn.querySelector('.atc-btn__label--idle');
        if (idle) idle.textContent = soldOut ? this.i18nSoldOut : (this.i18nAddToCart + ' ' + (v ? money(v.price * this.state.qty) : ''));
        this.ctaBtn.disabled = soldOut;
        this.ctaBtn.setAttribute('aria-disabled', soldOut ? 'true' : 'false');
      }
      if (this.errorEl) { this.errorEl.hidden = true; }

      KOLP.bus.emit('pf:update', { variant: v, qty: this.state.qty, soldOut: soldOut });
      KOLP.bus.emit('builder:update', {
        pack: this.state.qty, total: v ? v.price * this.state.qty : 0, valid: !soldOut,
        dominantColor: this.state.color
      });
    }

    /* Personalisation fields (snippets/personalise.liquid) ride along as
       line-item properties rather than variants: a free-text name crossed with
       an icon grid is not a variant matrix. Any [data-prop] inside this form
       contributes one, keyed by its label so it is readable in the cart, the
       checkout and the order — which is where production reads it. */
    collectProperties() {
      var props = {};
      var missing = [];
      KOLP.$$('[data-prop]', this).forEach(function (el) {
        var key = el.dataset.prop;
        var chosen = el.querySelector('[aria-checked="true"]');
        var value = el.matches('input, textarea, select')
          ? el.value.trim()
          /* the label, in the shopper's language — not the internal key */
          : (chosen ? (chosen.getAttribute('data-pers-icon-label') || chosen.getAttribute('data-pers-icon')) : '');
        if (value) {
          props[key] = value;
          /* …and the key alongside it, hidden, so production is not matching
             artwork against a translated word. */
          var hidden = el.dataset.propHidden;
          if (hidden && chosen) props[hidden] = chosen.getAttribute('data-pers-icon');
        } else if (el.dataset.propRequired === 'true') missing.push(key);
      });
      return { props: props, missing: missing };
    }

    async addToCart() {
      var v = this.currentVariant();
      if (!v || !v.available) { this.showError(this.i18nChooseOption); return; }

      var collected = this.collectProperties();
      if (collected.missing.length) {
        var warn = this.querySelector('[data-pers-warn]');
        if (warn) warn.hidden = false;
        var first = this.querySelector('[data-prop-required="true"]');
        if (first) {
          first.classList.add('is-missing');
          (first.matches('input') ? first : first.querySelector('button') || first).focus();
        }
        this.showError(this.i18nChooseOption);
        return;
      }

      var line = { id: v.id, quantity: this.state.qty };
      if (Object.keys(collected.props).length) line.properties = collected.props;

      this.setBtnState('loading');
      try {
        var res = await fetch((KOLP.routes.cart_add_url || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [line] })
        });
        if (!res.ok) {
          var e = await res.json().catch(function () { return {}; });
          throw new Error(e.description || e.message || ('Cart error ' + res.status));
        }
        var data = await res.json();
        this.setBtnState('done');
        KOLP.analytics && KOLP.analytics.track('add_to_cart', {
          item_id: v.id, value: (v.price * this.state.qty) / 100,
          currency: P ? P.getConfig().currency : 'EUR', quantity: this.state.qty
        });
        KOLP.bus.emit('cart:added', { added: data });
        setTimeout(function () { this.setBtnState('idle'); }.bind(this), 1500);
      } catch (err) {
        this.setBtnState('idle');
        this.showError(navigator.onLine
          ? this.i18nAddToCartError.replace('__MESSAGE__', err.message)
          : this.i18nOfflineError);
        KOLP.analytics && KOLP.analytics.track('add_to_cart_error', { message: err.message });
      }
    }

    setBtnState(s) { if (this.ctaBtn) this.ctaBtn.dataset.state = s; KOLP.bus.emit('builder:btnstate', { state: s }); }
    showError(msg) { if (this.errorEl) { this.errorEl.hidden = false; this.errorEl.textContent = msg; this.errorEl.setAttribute('role', 'alert'); } }
  }

  customElements.define('product-form', ProductForm);

  // sticky CTA delegation for standard PDPs
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sticky-cta]');
    if (!b) return;
    var pf = document.querySelector('product-form');
    if (pf) { e.preventDefault(); pf.addToCart(); }
  });
})();

/* ==========================================================================
   Personalisation controls — icon grid + name field with a live counter.
   Lives here rather than in its own file because it only ever appears inside
   <product-form>, whose addToCart() reads it. Does nothing on a page without
   a [data-personalise] block.
   ========================================================================== */
(function () {
  'use strict';
  var KOLP = window.KOLP || {};

  function init(root) {
    var warn = root.querySelector('[data-pers-warn]');
    var clearWarning = function () {
      if (warn) warn.hidden = true;
      KOLP.$$('.is-missing', root).forEach(function (el) { el.classList.remove('is-missing'); });
    };

    var grid = root.querySelector('[data-pers-grid]');
    if (grid) {
      var label = root.querySelector('[data-pers-icon-name]');
      grid.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-pers-icon]');
        if (!btn) return;
        KOLP.$$('[data-pers-icon]', grid).forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
        btn.setAttribute('aria-checked', 'true');
        if (label) label.textContent = btn.getAttribute('aria-label') || '';
        clearWarning();
      });
      /* Arrow keys move through a radiogroup; without this the grid is a
         keyboard dead end once it has focus. */
      grid.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        var all = KOLP.$$('[data-pers-icon]', grid);
        var i = all.indexOf(document.activeElement);
        if (i < 0) return;
        e.preventDefault();
        var step = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : -1;
        all[(i + step + all.length) % all.length].focus();
      });
    }

    var name = root.querySelector('[data-pers-name]');
    var count = root.querySelector('[data-pers-count]');
    if (name) {
      name.addEventListener('input', function () {
        if (count) count.textContent = String(name.value.length);
        if (name.value.trim()) clearWarning();
      });
    }
  }

  var start = function () { KOLP.$$('[data-personalise]').forEach(init); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
